import { useCallback } from 'react';

import { useSidebarEvents } from './service';

export const useHandlers = () => {
  const { trackNavigationItemClicked } = useSidebarEvents();

  const handleExtensionItemClick = useCallback(() => {
    trackNavigationItemClicked('Anyword Extension');
  }, [trackNavigationItemClicked]);

  return {
    handleExtensionItemClick,
  };
};
